import React, { useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import {
    _api_get_documents_hr,
    _api_get_documents_hr_delete_multiple,
    _api_get_documents_hr_download_multiple,
    _api_get_documents_hr_expenses,
    _api_get_documents_hr_timesheet,
    _api_get_employees,
    _api_get_search_documents_hr_common,
    _api_get_search_documents_hr_timereporting,
} from "../api/index.hr";
import {
    func_get_table_data,
    func_get_table_data_expenses,
    func_get_table_data_timesheet,
} from "../functions";
import { downloadFile } from "../../view_document/api";
import { useToastGlobal } from "../../../stores/useToastGlobal";
import { DOCUMENT_TYPE_HR, I18N_NS_DOCUMENTS } from "../constants";
import { _api_download_multiple_documents } from "../../../api/documents";
import { Flex, Skeleton, textAreaBehavior } from "@fluentui/react-northstar";
import { queryClient } from "../../..";
import { toast } from "sonner";
import useLogicSearchParams from "../../../hooks/useLogicSearchParams";
import { ROUTES } from "../../../constants/routes";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { QUERY_KEY_DOCUMENTS_HR_SEARCH_DOCUMENTS } from "./useLogicDocumentsHr";
import CellHeaderName from "../components/CellsContent/CellHeaderName";
import { useSortingData } from "../stores/sorting.store";
import { AVATAR_DEFAULT, AVATAR_DEPARTMENT_DEFAULT } from "../../../constants";
import { useTranslation } from "react-i18next";

const styles_cells = {
    name: {
        flex: 1,
        minWidth: "426px",
    },
    employee: {
        maxWidth: "230px",
        minWidth: "230px",
    },
    category: {
        maxWidth: "160px",
        minWidth: "142px",
        justifyContent: "center",
    },
    date_added: {
        maxWidth: "140px",
        minWidth: "140px",
    },
    button_more: {
        maxWidth: "99px",
        justifyContent: "end",
    },
};

export const TOAST_DONWLOADING_DOCUMENT = "toast_downloading_document";

const useLogicDocumentHrTimesheet = () => {
    // * CONSTANTS
    // * CONSTANTS
    // * CONSTANTS
    const QUERY_KEY_DOCUMENTS_HR = "documents_hr_timesheet";
    const QUERY_KEY_DOCUMENTS_HR_GET_FILES =
        QUERY_KEY_DOCUMENTS_HR + "::get_files";
    // * HOOKS
    // * HOOKS
    // * HOOKS
    const navigate = useNavigate();
    const { t } = useTranslation(I18N_NS_DOCUMENTS);
    const alert = useToastGlobal();
    const { searchParams, addQueryParams, setSearchParams } =
        useLogicSearchParams();

    // * STATES
    // * STATES
    // * STATES
    const [breadcrumb, setBreadcrumb] = React.useState([]);
    const [header, setHeader] = React.useState(null);
    const [rows, setRows] = React.useState([]);
    const [pathFile, setPathFile] = React.useState(null);
    const [showToolbar, setShowToolbar] = React.useState(false);
    const [downloadFolderId, setDownloadFolderId] = React.useState(null);

    const [resetDatesToNull, setResetDatesToNull] = React.useState(null);
    const [usersState, setUsersState] = React.useState([]);
    const store_sort = useSortingData();

    const enable_search =
        (searchParams.get("ud") !== null && searchParams.get("ud") !== "") ||
        (searchParams.get("sd") !== null && searchParams.get("sd") !== "") ||
        (searchParams.get("ed") !== null && searchParams.get("ed") !== "") ||
        false;

    const disable_reset_button =
        (searchParams.get("ud") === null || searchParams.get("ud") === "") &&
        (searchParams.get("sd") === null || searchParams.get("sd") === "") &&
        (searchParams.get("ed") === null || searchParams.get("ed") === "");

    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    const { data, isLoading, isFetching } = useQuery(
        [QUERY_KEY_DOCUMENTS_HR_GET_FILES, searchParams.toString()],
        (data) => {
            const path_file = data.queryKey.at(1);
            return _api_get_documents_hr_timesheet(path_file);
        },
        {
            enabled: !enable_search,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            onSuccess: (data) => {
                if (data?.breadcrumbs) {
                    // calculate format data for table.
                    const { header_format, breadcrumb_format, rows_format } =
                        func_get_table_data_timesheet(
                            data,
                            styles_cells,
                            handleDoubleClickRow,
                            handleClickRow,
                            handleCheckAll,
                            handleClickDownloadFolder,
                            handleClickDownloadFile,
                            store_sort.sortByName
                        );

                    setBreadcrumb(breadcrumb_format);
                    setRows(rows_format);
                    setHeader(header_format);
                }
            },
        }
    );

    const {
        data: data_search,
        isLoading: isLoadingSearchData,
        isFetching: isFetchingSearchData,
    } = useQuery(
        [QUERY_KEY_DOCUMENTS_HR_SEARCH_DOCUMENTS, searchParams.toString()],
        (data) => {
            const path_file = data.queryKey.at(1);
            return _api_get_search_documents_hr_timereporting(path_file);
        },
        {
            enabled: enable_search,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            onSuccess: (data) => {
                if (data?.breadcrumbs) {
                    // calculate format data for table
                    const { header_format, breadcrumb_format, rows_format } =
                        func_get_table_data_timesheet(
                            data,
                            styles_cells,
                            handleDoubleClickRow,
                            handleClickRow,
                            handleCheckAll,
                            handleClickDownloadFolder,
                            handleClickDownloadFile,
                            store_sort.sortByName
                        );

                    setBreadcrumb(breadcrumb_format);
                    setRows(rows_format);
                    setHeader(header_format);
                }
            },
        }
    );

    const { data: data_user_departments, isLoading: is_loading_employees } =
        useQuery(
            [QUERY_KEY_DOCUMENTS_HR + "::get_list_users_and_departments"],
            () => {
                return _api_get_employees();
            },
            {
                refetchOnWindowFocus: false,
            }
        );

    const { isLoading: isDownloadingDocument, mutate: mutateDownloadDocument } =
        useMutation((data) => downloadFile(data), {
            onSuccess: (data) => {
                toast.dismiss(TOAST_DONWLOADING_DOCUMENT);
                if (data?.success) {
                    alert.setShow({
                        ...alert,
                        visible: true,
                        level: "success",
                        content: "Téléchargement réussi",
                    });
                } else {
                    alert.setShow({
                        ...alert,
                        visible: true,
                        level: "danger",
                        content: data?.message
                            ? data?.message
                            : "le téléchargement a échoué",
                    });
                }
            },
        });

    const { isLoading: isDownloadingDocumentMultiple } = useQuery(
        [QUERY_KEY_DOCUMENTS_HR + "::download_multiple", downloadFolderId],
        (data) => {
            const downloadFolderId = data.queryKey.at(1);
            return _api_download_multiple_documents({
                items: downloadFolderId,
                document_type: DOCUMENT_TYPE_HR.timesheet,
            });
        },
        {
            enabled: downloadFolderId !== null,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            onSuccess: (data) => {
                toast.dismiss(TOAST_DONWLOADING_DOCUMENT);
                if (data?.success) {
                    alert.setShow({
                        ...alert,
                        visible: true,
                        level: "success",
                        content: "Téléchargement réussi",
                    });
                } else {
                    alert.setShow({
                        ...alert,
                        visible: true,
                        level: "danger",
                        content: data?.message
                            ? data?.message
                            : "le téléchargement a échoué",
                    });
                }
                setDownloadFolderId(null);
            },
        }
    );

    const {
        mutate: mutateDeleteDocumentMultiple,
        isLoading: isDeletingDocumentMultiple,
    } = useMutation((data) => _api_get_documents_hr_delete_multiple(data), {
        onSuccess: (data) => {
            if (data?.success) {
                // refetch data
                queryClient.invalidateQueries(QUERY_KEY_DOCUMENTS_HR_GET_FILES);

                alert.setShow({
                    ...alert,
                    visible: true,
                    level: "success",
                    content: "Suppression effectuée",
                });
            } else {
                alert.setShow({
                    ...alert,
                    visible: true,
                    level: "danger",
                    content: "La suppression a échouée",
                });
            }
            setDownloadFolderId(null);
        },
    });

    // * EFFECTS
    // * EFFECTS
    // * EFFECTS
    // calculate selected rows
    useEffect(() => {
        if (rows.length > 0) {
            const counter = _func_calculate_checked_items(rows);
            if (counter === 0) {
                setShowToolbar(false);
            } else {
                setShowToolbar(true);
            }
            if (counter === rows.length) {
                setHeader((old_state) => {
                    return {
                        ...old_state,
                        items: old_state.items.map((item, i) => {
                            if (i === 0) {
                                const isValid = React.isValidElement(
                                    item.content
                                );
                                const modifiedContent = isValid
                                    ? React.cloneElement(item.content, {
                                          checked: true,
                                          defaultChecked: true,
                                      })
                                    : item.content;
                                return {
                                    ...item,
                                    checked: true,
                                    content: modifiedContent,
                                };
                            } else {
                                return item;
                            }
                        }),
                    };
                });
            } else if (counter > 0) {
                setHeader((old_state) => {
                    return {
                        ...old_state,
                        items: old_state.items.map((item, i) => {
                            if (i === 0) {
                                const isValid = React.isValidElement(
                                    item.content
                                );
                                const modifiedContent = isValid
                                    ? React.cloneElement(item.content, {
                                          checked: "mixed",
                                          defaultChecked: "mixed",
                                      })
                                    : item.content;
                                return {
                                    ...item,
                                    checked: "mixed",
                                    content: modifiedContent,
                                };
                            } else {
                                return item;
                            }
                        }),
                    };
                });
            } else {
                setHeader((old_state) => {
                    return {
                        ...old_state,
                        items: old_state.items.map((item, i) => {
                            if (i === 0) {
                                const isValid = React.isValidElement(
                                    item.content
                                );
                                const modifiedContent = isValid
                                    ? React.cloneElement(item.content, {
                                          checked: false,
                                          defaultChecked: false,
                                      })
                                    : item.content;
                                return {
                                    ...item,
                                    checked: false,
                                    content: modifiedContent,
                                };
                            } else {
                                return item;
                            }
                        }),
                    };
                });
            }
        }
    }, [rows]);

    useEffect(() => {
        // calculate format data for table
        if (!data && !data_search) return;
        const { header_format, breadcrumb_format, rows_format } =
            func_get_table_data_timesheet(
                !data ? data_search : data,
                styles_cells,
                handleDoubleClickRow,
                handleClickRow,
                handleCheckAll,
                handleClickDownloadFolder,
                handleClickDownloadFile,
                store_sort.sortByName
            );

        setBreadcrumb(breadcrumb_format);
        setRows(rows_format);
        setHeader(header_format);
    }, [store_sort.sortByName]);

    // * FUNCTIONS
    // * FUNCTIONS
    // * FUNCTIONS

    const handleDatesChange = (dates) => {
        console.log("Dates sélectionnées:", dates);
    };
    const handleBreadcrumbItemClick = (key) => {
        setRows([]);
        if (key) {
            addQueryParams({ f: key });
        } else {
            addQueryParams();
        }
        return;
    };
    const handleDoubleClickRow = ({
        row_id,
        is_folder,
        name,
        document_type,
    }) => {
        if (is_folder) {
            addQueryParams({ c: name, f: row_id });
            return;
        }
        navigate(
            `${ROUTES.detail_document.home}?fid=${row_id}&dt=${document_type}`
        );
        return;
    };
    const handleClickRow = (row_id) => {
        // select/deselect one row
        setRows((old_state) => {
            return old_state.map((row) => {
                if (row.key === row_id) {
                    const check = !row.checked ? true : false;
                    return {
                        ...row,
                        checked: check,
                        items: row.items.map((item, i) => {
                            if (i === 0) {
                                const isValid = React.isValidElement(
                                    item.content
                                );
                                const modifiedContent = isValid
                                    ? React.cloneElement(item.content, {
                                          checked: check,
                                          defaultChecked: check,
                                      }) // Modifier une prop
                                    : item.content;
                                return {
                                    ...item,
                                    checked: check,
                                    content: modifiedContent,
                                };
                            } else {
                                return item;
                            }
                        }),
                    };
                }
                return row;
            });
        });
        return;
    };
    // check rows or header
    const handleCheckAll = (checked) => {
        if (checked) {
            // show toolbar
            setShowToolbar(true);
        } else {
            setShowToolbar(false);
        }
        // selectionner/deselectionner toutes les lignes
        setRows((old_state) => {
            return old_state.map((row) => {
                return {
                    ...row,
                    checked: checked,
                    items: row.items.map((item, i) => {
                        if (i === 0) {
                            const isValid = React.isValidElement(item.content);
                            const modifiedContent = isValid
                                ? React.cloneElement(item.content, {
                                      checked: checked,
                                      defaultChecked: checked,
                                  }) // Modifier une prop
                                : item.content;
                            return {
                                ...item,
                                checked: checked,
                                content: modifiedContent,
                            };
                        } else {
                            return item;
                        }
                    }),
                };
            });
        });
        // gerer le header aussi

        setHeader((old_state) => {
            return {
                ...old_state,
                items: old_state.items.map((item, i) => {
                    if (i === 0) {
                        const isValid = React.isValidElement(item.content);
                        const modifiedContent = isValid
                            ? React.cloneElement(item.content, {
                                  checked: checked,
                                  defaultChecked: checked,
                              }) // Modifier une prop
                            : item.content;
                        return {
                            ...item,
                            checked: checked,
                            content: modifiedContent,
                        };
                    } else {
                        return item;
                    }
                }),
            };
        });
    };

    // calculate selected rows
    const _func_calculate_checked_items = (rows) => {
        let counter = 0;
        rows.forEach((row) => {
            if (row.checked) {
                counter++;
            }
        });
        return counter;
    };
    // verify if selections contains folder
    const _func_is_selections_contains_folder = () => {
        let contains = false;
        rows.forEach((row) => {
            if (row.is_folder && row.checked) {
                return (contains = true);
            }
        });
        return contains;
    };

    const handleClickDownloadFolder = ({ folder_id }) => {
        return setDownloadFolderId(
            "?item=" + folder_id + "&dt=" + DOCUMENT_TYPE_HR.timesheet
        );
    };

    const handleClickDownloadFile = ({ file_id, document_type }) => {
        mutateDownloadDocument({ document_id: file_id, document_type });
        return;
    };

    const format_data_user = (data_user_departments) => {
        return data_user_departments?.map((item) => {
            return {
                key: item.id,
                header: item.name,
                content: item.job_title,
                image: {
                    src: item?.is_department
                        ? AVATAR_DEPARTMENT_DEFAULT
                        : item.avatar
                        ? item.avatar
                        : AVATAR_DEFAULT,
                    onError: ({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = AVATAR_DEFAULT;
                    },
                },
                is_department: item.is_department,
            };
        });
    };

    const skeletonTable = React.useMemo(() => {
        return Array.from({ length: 10 }, (_, i) => ({
            key: i,
            items: [
                {
                    key: "name",
                    styles: styles_cells.name,
                    content: (
                        <Skeleton animation="pulse">
                            <Flex gap="gap.small" vAlign="center">
                                <Skeleton.Line width="24px" height="24px" />
                                <Skeleton.Shape
                                    round
                                    width="24px"
                                    height="24px"
                                />
                                <Skeleton.Line width="183px" height="24px" />
                            </Flex>
                        </Skeleton>
                    ),
                },
                {
                    key: "employee",
                    styles: styles_cells.employee,
                    content: (
                        <Skeleton animation="pulse">
                            <Flex gap="gap.small" vAlign="center">
                                <Skeleton.Shape
                                    round
                                    width="24px"
                                    height="24px"
                                />
                                <Skeleton.Line width="104px" height="24px" />
                            </Flex>
                        </Skeleton>
                    ),
                },
                {
                    key: "category",
                    content: " ",
                    styles: styles_cells.category,
                },
                {
                    key: "date_added",
                    content: " ",
                    styles: styles_cells.date_added,
                },
                {
                    key: "button_more",
                    content: (
                        <Skeleton animation="pulse">
                            <Flex gap="gap.small" vAlign="center">
                                <Skeleton.Line width="24px" height="24px" />
                            </Flex>
                        </Skeleton>
                    ),
                    styles: styles_cells.button_more,
                },
            ],
        }));
    }, []);

    const skeletonHeader = React.useMemo(() => {
        return {
            key: "header",
            items: [
                {
                    content: <CellHeaderName disabled={true} />,
                    key: "name",
                    styles: styles_cells.name,
                },
            ],
        };
    }, []);

    const defaultSelectedUsers = searchParams.getAll("ud");

    return {
        t,
        query: {
            data,
            isLoading: isLoading || isLoadingSearchData,
            isFetching: isFetching || isFetchingSearchData,
        },
        functions: {
            handleDatesChange,
            handleBreadcrumbItemClick,
            handleCheckAll,
        },
        table: {
            header,
            rows,
            skeleton: skeletonTable,
            skeleton_header: skeletonHeader,
        },
        breadcrumb,
        path_folders: {
            path: pathFile,
            setPath: setPathFile,
        },
        toolbar: {
            show: showToolbar,
            setShow: setShowToolbar,
            counter: showToolbar ? _func_calculate_checked_items(rows) : null,
            disableDelete: true,
            isDownloadingDocumentMultiple,
            isDeletingDocumentMultiple,
            mutateDeleteDocumentMultiple: (e) => {
                e.preventDefault();
                e.stopPropagation();
                const selected = rows.filter((row) => row.checked);
                const document_ids = selected.map((row) => row.key);
                const format_items = document_ids
                    ? "?" + document_ids.map((item) => `item=${item}`).join("&")
                    : null;
                mutateDeleteDocumentMultiple({
                    items: format_items,
                    document_type: DOCUMENT_TYPE_HR.hr,
                });
            },
            mutateDownloadDocumentMultiple: (e) => {
                e.preventDefault();
                e.stopPropagation();
                const selected = rows.filter((row) => row.checked);
                const document_ids = selected.map((row) => row.key);
                const format_items = document_ids
                    ? "?" + document_ids.map((item) => `item=${item}`).join("&")
                    : null;

                setDownloadFolderId(format_items);
            },
        },
        filter: {
            user_departments: {
                data: format_data_user(data_user_departments) ?? [],
                isLoading: is_loading_employees,
            },
            disable_reset_button,
            defaultSelectedUsers,
            resetDatesToNull,
            usersState,
            searchParams,
            setResetDatesToNull,
            setUsersState,
            setSearchParams,
            onChangeUsersDepartments: (e, i) => {
                const newParams = new URLSearchParams(searchParams);
                newParams.delete("ud");
                const value = i.value;
                if (value.length === 0) {
                    setUsersState([]);
                } else {
                    value.forEach((val) => newParams.append("ud", val.key));
                }
                setUsersState(value);
                return setSearchParams(newParams);
            },
            onDatesChange: (dates) => {
                if (dates.end !== null && dates.start !== null) {
                    const newParams = new URLSearchParams(searchParams);
                    const sd = dates.start.toLocaleDateString("fr-FR");
                    newParams.set(
                        "sd",
                        moment(sd, "DD/MM/YYYY").format("YYYY-MM-DD")
                    );
                    const ed = dates.end.toLocaleDateString("fr-FR");
                    newParams.set(
                        "ed",
                        moment(ed, "DD/MM/YYYY").format("YYYY-MM-DD")
                    );
                    return setSearchParams(newParams);
                } else {
                    const newParams = new URLSearchParams(searchParams);
                    newParams.delete("sd");
                    newParams.delete("ed");
                    return setSearchParams(newParams);
                }
            },
        },
    };
};

export default useLogicDocumentHrTimesheet;
